import EditableCell from './editable-cell';
export default EditableCell;